import TeamView from './TeamView';

export default TeamView;
